<template>
  <div class="index">
    <div class="head"></div>

    <div class="container2">
      <div class="tableContent">
        <div class="tableHead">
          <div class="left">标题</div>
          <div class="mid">内容</div>
          <div class="right"></div>
        </div>

        <div class="tableBody" v-for="item in inContentList" :key="item.id">
          <div class="left">
            <div class="inLeft">
              <div class="leftTitle">{{ item.title }}</div>
              <div class="leftTime">{{ item.pubtime | filterTime }}</div>
            </div>
          </div>
          <div class="mid">
            <div class="inMid">
              {{ item.content }}
            </div>
          </div>
          <div class="right">
            <a :href="item.url"
              ><div class="inRight">查看</div>
              <div class="inRight">详情</div></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import qs from "qs";

export default {
  data() {
    return {
      inContentList: [],
    };
  },
  filters: {
    filterTime: function (value) {
      return (value = value.substring(0, 11));
    },
  },
  methods: {
    getCmsInfo() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "GOVERNMENTNOTICE",
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          Toast.clear();
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          } else {
            this.inContentList = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.log(err);
        });
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
  mounted() {
    // this.getToken();
    this.getCmsInfo();
  },
};
</script>


<style lang="scss" scoped>
.index {
  width: 100%;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  overflow: scroll;
  .head {
    width: 100%;
    height: 8.8rem;
    background-image: url(../assets/images/bg.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.container2 {
  position: absolute;
  top: 7.7rem;
  width: 100%;
  border-radius: 0.8rem;
  .tableContent {
    background-color: #ffffff;
    padding: 1.875rem 2rem 25rem 2rem;
    overflow: auto;
    border-radius: 1rem;

    .tableHead {
      display: flex;
      height: 3.625rem;
      border: 1px solid #e3e3e3;
      .left {
        width: 10.5rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        // font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .mid {
        width: 25.875rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        // font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .right {
        flex-grow: 1;
      }
    }
    .tableBody {
      display: flex;
      border: 1px solid #e3e3e3;
      border-top: none;

      .left {
        width: 10.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        text-align: center;
        .inLeft {
          .leftTitle {
            color: #19212a;
            font-size: 1.75rem;
            // padding: 0 0.5rem 0 1rem;
          }
          .leftTime {
            color: #878787;
            font-size: 1.375rem;
            text-align: center;
            margin-top: 0.5rem;
          }
        }
      }
      .mid {
        width: 25.875rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        .inMid {
          color: #555555;
          font-size: 1.75rem;
          padding: 2.125rem 1.375rem 2.25rem 1.125rem;
        }
      }
      .right {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .inRight {
          color: #338989;
          font-size: 1.75rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
